import { getWorkItemResources } from '@jira/router-resources__work-item-view/src/workItemResourcesRouteResource.tsx';
import { WorkItemViewSkeleton } from '@jira/work-item__work-item-view-skeleton/src/WorkItemViewSkeleton.tsx';

import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { gicOptInStatusResources } from '@jira/router-resources__global-issue-create-switch/src/gicOptInStatusResources.tsx';
import { workItemConditionalListResources } from '@jira/router-resources__work-item-conditional-list/src/workItemConditionalListResources.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { workItemEmbedRoute } from '@jira/router-routes__work-item-routes/src/workItemEmbedRoute.tsx';
import type { BifrostRedirectHandlerPayload } from '@jira/platform__routing-route-types/src/JiraSpaRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { issueDescriptionSmartlinkDataResource } from '@jira/router-resources__issue-view/src/issueDescriptionSmartlinkDataResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { getModernIssueTransitionResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { loomPermissionResource } from '@jira/router-resources__loom/src/loomPermissionResource.tsx';
import { workItemPageEntrypoint } from './ui/index.tsx';
import { workItemRedirectionHandler } from './common/workItemRedirectionHandler.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';

export const workItemEmbedRouteEntry: Route = createEntry(workItemEmbedRoute, () => ({
	group: 'work-item',
	// bifrost property is set up, which is required for Bifrost SSR onboarding
	bifrost: {
		bifrostGroup: 'issue-view',
		manifestName: 'jira-spa-issue-view.json',
		redirects: [
			{
				key: 'work-item-project-context-redirect',
				timeoutMs: 1000,
				handler: ({ match, url, tenantContext }: BifrostRedirectHandlerPayload) =>
					workItemRedirectionHandler({ match, url, tenantContext, isEmbed: true }),
			},
		],
	},
	meta: {
		capability: 'WORK_ITEM_VIEW',
	},
	resources: [
		...getIssueViewResources({ disableShadowQuery: true }),
		...getModernIssueTransitionResources(),
		gicOptInStatusResources,
		...jiraSpaResources(),
		projectContextResource,
		// List view resources (loaded when ?hasList=true)
		workItemConditionalListResources.conditionalIssueNavigatorResource,
		workItemConditionalListResources.conditionalFieldsResource,
		workItemConditionalListResources.conditionalProjectContextResource,
		...getWorkItemResources(),
		resourceWithCondition(() => fg('wi2-perf-smart-links'), issueDescriptionSmartlinkDataResource),
		loomPermissionResource,
	],
	skeleton: WorkItemViewSkeleton,
	entryPoint: () => workItemPageEntrypoint,
	ufoName: 'work-item',
	fallbackExperience: 'work-item-view',
	supportsPreviewPanel: true,
	isHydrateRootEnabled: true,
	layout: chromelessLayout,
	excludeFromWrmDeferredLoading: true,
}));
